import { queryOptions } from '@tanstack/react-query'
import { PublicFootballRequestError } from '~/lib/public-football-read'
import { fetchFootballMatchDetail } from './api'

export const footballMatchDetailQueryKeys = {
  detail: (matchId: string) => ['football-match-detail', matchId] as const,
}

export function footballMatchDetailQueryOptions(matchId: string) {
  return queryOptions({
    queryKey: footballMatchDetailQueryKeys.detail(matchId),
    queryFn: ({ signal }) => fetchFootballMatchDetail(matchId, signal),
    staleTime: 15_000,
    retry: (failureCount, error) =>
      !(error instanceof PublicFootballRequestError && error.status === 404)
      && failureCount < 2,
  })
}
